const collectQuestionValue = (q, formData) => {
  if (
    q.QuestionType === "MultiChoiceCheckQuestion" ||
    q.QuestionType === "MultiChoiceRadioQuestion" ||
    q.QuestionType === "MultiChoiceDropdownQuestion"
  ) {
    q.Value = formData.getAll(q.Name);
    if (q.AddOther) {
      q.Value.push(formData.get(`${q.Name}_other`));
    }
  } else {
    q.Value = [formData.get(q.Name)];

    if (
      q.ValidationType === "Medicare number" ||
      q.ValidationType === "Medicare Number"
    ) {
      const digits = q.Value[0] ? q.Value[0].replace(/\D/g, "") : q.Value[0];
      const irn = formData.get(`${q.Name}_irn`) || "";
      q.Value = [digits ? `${digits}${irn}` : digits];
    }
  }

  if (q.Options) {
    q.Options.forEach((o) => {
      if (o.Questions) {
        o.Questions = o.Questions.map((subQuestion) =>
          collectQuestionValue(subQuestion, formData),
        );
      }
    });
  }

  return q;
};

export default collectQuestionValue;
